import Action from '../base/action';

class WorkspaceTermination extends Action {
    shouldEnd;

    constructor(props) {
        super(props);
        this.shouldEnd = props.shouldEnd;
    }

    async execute(eventLoop) {
        if(this.shouldEnd === true && wv.effectController.meetingInfo.data.type === MeetingType.TRAINING) {
            await eventLoop.training.end();
            if (wv.settings?.redirectURL) {
                window.location = wv.settings.redirectURL;
                return;
            }

            userConfirmationManager.onTrainingEnd();
        }
    }
}

export default WorkspaceTermination;
